<template>
  <div>
    <jet-label :for="computedName" :value="computedLabel" :required="required" />
    <slot v-bind="{ computedName }">
      <jet-input
        :id="computedName"
        v-model="localValue"
        :type="type"
        class="block w-full mt-1"
        :autocomplete="computedName"
        :required="required"
        :autofocus="autofocus"
      />
    </slot>
    <div v-if="Array.isArray(error)">
      <jet-input-error v-for="e in error" :key="e" :message="e" class="mt-2" />
    </div>
    <jet-input-error v-else :message="error" class="mt-2" />
    <p v-if="helper" class="mt-1 text-xs italic text-gray-400">{{ helper }}</p>
  </div>
</template>

<script>
import _ from 'lodash'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import FormInput from '@/Mixins/FormInput'

export default {
  components: { JetInput, JetLabel, JetInputError },

  mixins: [FormInput],

  props: {
    type: {
      type: String,
      default: 'text',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    computedLabel () {
      return this.label || _.startCase(this.name) || ''
    },

    computedName () {
      return this.name || _.snakeCase(this.label) || 'form-input-' + Math.floor(Math.random() * 1000)
    },
  },
}
</script>
